// extracted by mini-css-extract-plugin
module.exports = {"postList":"BlogPostList_postList__4EW_S","postDate":"BlogPostList_postDate__X1c3u","bullet":"BlogPostList_bullet__iVH2b","fade_in":"BlogPostList_fade_in__ou4xH"};